import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as AppState from '../../../../state/app.state';
import { DataImportLogState } from "./data-import-logs.reducer";

export interface State extends AppState.State {
    dataImportLogState: DataImportLogState;
}

const getDataImportLogStateFeatureState = createFeatureSelector<DataImportLogState>('dataImportLogs');

export const getDataImportLogStateData = createSelector(
    getDataImportLogStateFeatureState,
    state => state.logs
        .filter((val, index, arr) =>
            arr.findIndex(l => (`${l.inputFileName}_${l.logType}_${l.message}` === `${val.inputFileName}_${val.logType}_${val.message}`)) === index)
);

// object filtering reference: https://stackoverflow.com/questions/2218999/how-to-remove-all-duplicates-from-an-array-of-objects
